import { IntlShape } from 'react-intl';
import { createSelector } from 'reselect';

import { getHints, getSenderProfile } from 'platform-components/src/components/user/selectors';
import { intlSelector } from 'utils/selectors/selectors';

import { HowToStartModalStore } from './typings';

export const HOW_TO_START_MODAL_SEEN = 'how_to_start_modal_seen';

const modalSelector = <T extends { howToStartModal: HowToStartModalStore }>(storeState: T) =>
    storeState.howToStartModal;

export const getIsOpenedManually = createSelector(
    modalSelector,
    (state: HowToStartModalStore) => state.isOpenedManually || false
);

export const getIsOpenedAutomatically = createSelector(
    modalSelector,
    (state: HowToStartModalStore) => state.isOpenedAutomatically || false
);

const getIsHowToStartModalSeenBefore = createSelector(
    [getHints, getSenderProfile],
    // Use (legacy) email form close count to check whether to
    // show "How to start" modal in addition to the `viewed_hints`
    (hints, profile): boolean => Boolean(hints?.[HOW_TO_START_MODAL_SEEN]) || (profile?.count_form_closed || 0) > 0
);

export const getShouldShowHowToStartModal = createSelector(
    [getIsHowToStartModalSeenBefore, getIsOpenedAutomatically, getIsOpenedManually, intlSelector],
    (
        modalSeenBefore,
        isOpenedAutomatically,
        isOpenedManually,
        intl: IntlShape
        // eslint-disable-next-line max-params
    ) => {
        if (isOpenedManually) {
            return true;
        }

        const isModalOn = intl.formatMessage({ id: 'howToStartModal.automatical.active' }) === 'true';

        return !modalSeenBefore && isOpenedAutomatically && isModalOn;
    }
);
